"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var ContentType;
(function (ContentType) {
    ContentType["Hero"] = "hero";
    ContentType["Rail"] = "listing";
    ContentType["ContinueWatching"] = "continue-watching";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
//# sourceMappingURL=ContentType.js.map